module.exports = __webpack_public_path__ + "img/88f2c56f48bf3ebf80846b77bf102dc2.png";